export default "__VITE_ASSET__CNNtRvXc__"